import React from 'react';
import moment from 'moment';
import Sort from '../../Common/Sort/Sort';
import CardSearch from '../../Common/CardSearch';
import './AggregatorNewsTab.scss';
import NoResultsBox from '../../Common/NoResultsBox/NoResultsBox';

const sortSentiment = [
    "Date: Newest to Oldest",
    "Date: Oldest to Newest",
    // "Sentiment: Positive to Negative",
    // "Sentiment: Negative to Positive",
];

const sentimentConfig = {
    positive: { color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0", label: "Positive" },
    negative: { color: "#dc2626", bg: "#fff1f2", border: "#fecdd3", label: "Negative" },
    neutral:  { color: "#d97706", bg: "#fffbeb", border: "#fde68a", label: "Neutral"  },
};

const getSentiment = (s) => sentimentConfig[s?.toLowerCase()] || sentimentConfig.neutral;

/**
 * The `AggregatorNewsTab` component displays a tab containing aggregated news data.
 *
 * This function is called in \src\Component\NewsAggregator\NewsAggregator.jsx
 */
const AggregatorNewsTab = ({
    data,
    open,
    onOpenChange,
    onShow,
    optionsData,
    onSearchChange,
    searchValue,
    onsortByScore,
}) => {
    return (
        <div className="agg-news-panel">

            {/* ── Header ── */}
            <div className="agg-news-header">
                <div className="agg-news-header-left">
                    <span className="agg-news-title">News</span>
                    {data.length > 0 && (
                        <span className="agg-news-count">{data.length}</span>
                    )}
                </div>
                <div className="agg-news-header-right">
                    <span className="agg-search-label">Search Sources</span>
                    <CardSearch
                        open={open}
                        onOpenChange={onOpenChange}
                        onShow={onShow}
                        data={optionsData}
                        onSearchChange={onSearchChange}
                        value={searchValue}
                        placeholder="Search Sources"
                    />
                    <Sort
                        sortSentiment={sortSentiment}
                        sortByScore={onsortByScore}
                        title="Sort By"
                    />
                </div>
            </div>

            {/* ── Card List ── */}
            <div className="agg-news-list">
                {data.length > 0 ? (
                    data.map((news, index) => {
                        const s = getSentiment(news?.news_sentiment);
                        return (
                            <a
                                key={index}
                                href={news?.news_link}
                                target="_blank"
                                rel="noreferrer"
                                className="agg-news-card-link"
                            >
                                <div
                                    className="agg-news-card"
                                    style={{ borderLeftColor: s.color }}
                                >
                                    {/* Top row: source pill + sentiment badge */}
                                    <div className="agg-card-top">
                                        {news?.news_source && (
                                            <span className="agg-source-pill">
                                                {news.news_source}
                                            </span>
                                        )}
                                        <span
                                            className="agg-sentiment-badge"
                                            style={{
                                                color: s.color,
                                                background: s.bg,
                                                border: `1px solid ${s.border}`,
                                            }}
                                        >
                                            {s.label}
                                        </span>
                                    </div>

                                    {/* Title */}
                                    <p className="agg-card-title">{news.title}</p>

                                    {/* Bottom row: date + arrow */}
                                    <div className="agg-card-bottom">
                                        <span className="agg-card-date">
                                            &#128197;&nbsp;
                                            {news.news_date
                                                ? moment(news.news_date).format("DD MMM YYYY, HH:mm")
                                                : "—"}
                                        </span>
                                        <span className="agg-card-arrow">&#8599;</span>
                                    </div>
                                </div>
                            </a>
                        );
                    })
                ) : (
                    <NoResultsBox displayText="No Data" showEmptyImage={true} />
                )}
            </div>
        </div>
    );
};

export default AggregatorNewsTab;
